import { Button, Spinner } from '@material-tailwind/react'
import PropTypes from 'prop-types'

export const AccessButtons = ({ handleSubmit, loading, isOfficePreselected, officeId }) => (
  <>
    <div className="flex flex-col sm:flex-row sm:gap-2 gap-1">
      <Button
        onClick={(e) => handleSubmit(e, 'entry')}
        fullWidth
        disabled={loading || (!isOfficePreselected && (!officeId || officeId === 'all'))}
        color="green"
        className="flex items-center justify-center gap-2"
      >
        {loading ? <Spinner className="h-4 w-4" /> : 'Registrar Entrada'}
      </Button>

      <Button
        onClick={(e) => handleSubmit(e, 'exit')}
        fullWidth
        disabled={loading || (!isOfficePreselected && (!officeId || officeId === 'all'))}
        color="red"
        className="flex items-center justify-center gap-2"
      >
        {loading ? <Spinner className="h-4 w-4" /> : 'Registrar Salida'}
      </Button>
    </div>
  </>
)

AccessButtons.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  isOfficePreselected: PropTypes.bool.isRequired,
  officeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}
